var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVintage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1885_2184",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 68,
    width: 235,
    height: 116
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M244.478 68.4443H10V183.647H244.478V68.4443Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1885_2184)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.6434 115.079L71.1 120.51V129.597L98.3078 157.17L74.9645 147.979L74.7034 147.875L41.6989 136.229H17.99C15.8489 136.229 13.8644 135.446 12.35 133.931C10.8355 132.417 9.94775 130.432 9.94775 128.291V118.578C9.94775 114.191 13.4989 110.64 17.8855 110.64H41.5944L97.0023 93.459",
    fill: "#343334"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3892 127.245L89.9 138.734V111.683L54.4936 121.501C51.6214 122.284 51.5169 126.358 54.3892 127.245Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.887 135.76L183.43 130.328V121.242L156.222 93.6685L179.566 102.86L179.827 102.964L212.831 114.61H236.488C238.629 114.61 240.613 115.393 242.128 116.907C243.642 118.422 244.53 120.406 244.53 122.547V132.261C244.53 136.647 240.979 140.198 236.592 140.198H212.883L157.476 157.38",
    fill: "#343334"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.089 123.59L164.578 112.102V139.153L199.984 129.335C202.857 128.552 202.961 124.478 200.089 123.59Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.951 73.2069L74.4913 117.667C69.8618 122.296 69.8618 129.802 74.4913 134.431L118.951 178.891C123.581 183.521 131.086 183.521 135.716 178.891L180.175 134.431C184.805 129.802 184.805 122.296 180.175 117.667L135.716 73.2069C131.086 68.5775 123.581 68.5775 118.951 73.2069Z",
    fill: "white",
    stroke: "#343333",
    strokeWidth: 2.61111,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.703 148.134C100.397 148.134 99.2484 148.813 98.5695 149.909C98.0995 150.745 97.9428 151.685 98.2039 152.573C98.4651 153.513 99.0395 154.244 99.8751 154.766C101.598 155.758 103.792 155.184 104.784 153.46C105.254 152.625 105.411 151.685 105.149 150.797C104.888 149.857 104.314 149.074 103.478 148.604C102.904 148.29 102.277 148.134 101.651 148.134H101.703Z",
    stroke: "#343333",
    strokeWidth: 2.61111,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.451 138.422C92.8766 138.422 92.2499 138.579 91.6755 138.892C90.8399 139.362 90.2655 140.093 90.0044 141.033C89.7432 141.921 89.8999 142.861 90.3699 143.696C90.8399 144.532 91.6232 145.106 92.511 145.367C93.451 145.629 94.391 145.472 95.2266 145.002L95.6444 144.741C96.271 144.271 96.6888 143.592 96.8977 142.913C97.1588 142.025 97.0021 141.085 96.5321 140.25C96.0621 139.414 95.2788 138.84 94.391 138.579C94.0777 138.474 93.8166 138.422 93.451 138.422Z",
    stroke: "#343333",
    strokeWidth: 2.61111,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.7255 98.8369L98.5688 99.098C98.0988 99.9336 97.9944 100.874 98.2555 101.814C98.5166 102.701 99.091 103.485 99.9266 103.955C100.762 104.425 101.702 104.529 102.642 104.268C103.582 104.007 104.313 103.432 104.783 102.597C105.253 101.761 105.358 100.821 105.097 99.9336C104.835 99.0458 104.261 98.2624 103.425 97.7924C101.859 96.8524 99.7177 97.3747 98.6733 98.8891L98.7255 98.8369Z",
    stroke: "#343333",
    strokeWidth: 2.61111,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.027 105.627C160.348 105.627 159.773 105.784 159.251 106.097C158.416 106.567 157.841 107.351 157.58 108.239C157.319 109.126 157.476 110.066 157.946 110.902C158.416 111.737 159.199 112.364 160.139 112.573C161.027 112.834 162.019 112.677 162.854 112.207C163.69 111.737 164.264 111.006 164.526 110.119C164.787 109.179 164.682 108.239 164.212 107.403C163.586 106.306 162.384 105.627 161.131 105.627H161.027Z",
    stroke: "#343333",
    strokeWidth: 2.61111,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.027 138.422C160.348 138.422 159.773 138.579 159.251 138.892C158.416 139.362 157.841 140.145 157.58 141.033C157.319 141.921 157.476 142.861 157.946 143.696C158.416 144.532 159.199 145.159 160.139 145.367C161.027 145.629 162.019 145.472 162.854 145.002C163.69 144.532 164.264 143.801 164.526 142.913C164.787 141.973 164.682 141.033 164.212 140.197C163.586 139.101 162.384 138.422 161.131 138.422H161.027Z",
    stroke: "#343333",
    strokeWidth: 2.61111,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.841 89.6978C110.371 89.6978 109.692 89.8022 109.065 90.1678C108.23 90.6378 107.655 91.4211 107.394 92.3611C107.133 93.2489 107.29 94.2411 107.76 95.0244C108.752 96.7478 110.945 97.3222 112.668 96.33C113.504 95.86 114.078 95.0766 114.34 94.1366C114.601 93.2489 114.444 92.2566 113.974 91.4733C113.347 90.3766 112.146 89.6978 110.841 89.6978Z",
    stroke: "#343333",
    strokeWidth: 2.61111,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.841 155.654C110.371 155.654 109.692 155.758 109.065 156.124C108.23 156.594 107.655 157.377 107.394 158.317C107.133 159.205 107.29 160.197 107.76 160.98C108.752 162.704 110.945 163.278 112.668 162.286C113.504 161.816 114.078 161.033 114.34 160.093C114.601 159.205 114.444 158.213 113.974 157.429C113.347 156.333 112.146 155.654 110.841 155.654Z",
    stroke: "#343333",
    strokeWidth: 2.61111,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.158 89.6978C143.688 89.6978 143.009 89.8022 142.383 90.1678C141.547 90.6378 140.973 91.4211 140.712 92.3611C140.45 93.2489 140.607 94.2411 141.077 95.0244C142.069 96.7478 144.263 97.3222 145.986 96.33C146.822 95.86 147.396 95.0766 147.657 94.1366C147.918 93.2489 147.762 92.2566 147.292 91.4733C146.665 90.3766 145.464 89.6978 144.158 89.6978Z",
    stroke: "#343333",
    strokeWidth: 2.61111,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.158 156.335C143.688 156.335 143.009 156.439 142.383 156.805C141.547 157.275 140.973 158.058 140.712 158.998C140.45 159.886 140.607 160.878 141.077 161.662C142.069 163.385 144.263 163.959 145.986 162.967C146.822 162.497 147.396 161.714 147.657 160.774C147.918 159.886 147.762 158.894 147.292 158.111C146.665 157.014 145.464 156.335 144.158 156.335Z",
    stroke: "#343333",
    strokeWidth: 2.61111,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.82 97.3223C153.455 97.3223 153.193 97.3223 152.932 97.4267C151.94 97.6878 151.209 98.2623 150.739 99.0456C150.269 99.8812 150.112 100.821 150.373 101.761C150.635 102.701 151.209 103.432 152.045 103.954C153.768 104.894 155.961 104.32 156.953 102.649C157.423 101.813 157.58 100.873 157.319 99.9856C157.058 99.0456 156.483 98.2623 155.648 97.7923C155.073 97.4789 154.447 97.3223 153.82 97.3223Z",
    stroke: "#343333",
    strokeWidth: 2.61111,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.82 147.561C153.455 147.561 153.193 147.561 152.932 147.665C151.94 147.926 151.209 148.501 150.739 149.284C150.269 150.119 150.112 151.059 150.373 151.999C150.635 152.939 151.209 153.671 152.045 154.193C153.768 155.133 155.961 154.558 156.953 152.887C157.423 152.052 157.58 151.112 157.319 150.224C157.058 149.284 156.483 148.501 155.648 148.031C155.073 147.717 154.447 147.561 153.82 147.561Z",
    stroke: "#343333",
    strokeWidth: 2.61111,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.5 96.488C122.33 96.488 118.1 92.3103 118.1 87.1403C118.1 81.9703 122.33 77.7925 127.5 77.7925C132.67 77.7925 136.9 81.9703 136.9 87.1403C136.9 92.3103 132.67 96.488 127.5 96.488Z",
    stroke: "#343333",
    strokeWidth: 2.61111,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.5 174.977C122.33 174.977 118.1 170.8 118.1 165.63C118.1 160.46 122.33 156.282 127.5 156.282C132.67 156.282 136.9 160.46 136.9 165.63C136.9 170.8 132.67 174.977 127.5 174.977Z",
    stroke: "#343333",
    strokeWidth: 2.61111,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.823 135.287C161.653 135.287 157.423 131.11 157.423 125.94C157.423 120.77 161.653 116.592 166.823 116.592C171.993 116.592 176.223 120.77 176.223 125.94C176.223 131.11 171.993 135.287 166.823 135.287Z",
    stroke: "#343333",
    strokeWidth: 2.61111,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.6538 135.287C82.4838 135.287 78.2538 131.11 78.2538 125.94C78.2538 120.77 82.4838 116.592 87.6538 116.592C92.8238 116.592 97.0539 120.77 97.0539 125.94C97.0539 131.11 92.8238 135.287 87.6538 135.287Z",
    stroke: "#343333",
    strokeWidth: 2.61111,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4744 107.193L90.3178 107.454C89.8478 108.29 89.7433 109.23 90.0044 110.17C90.2656 111.057 90.84 111.841 91.6756 112.311C92.5111 112.781 93.4511 112.885 94.3911 112.624C95.3311 112.363 96.0622 111.788 96.5322 110.953C97.0022 110.117 97.1067 109.177 96.8456 108.29C96.5844 107.402 96.01 106.618 95.1744 106.148C93.6078 105.208 91.4667 105.731 90.4222 107.245L90.4744 107.193Z",
    stroke: "#343333",
    strokeWidth: 2.61111,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.239 97.4268C111.311 97.4268 98.36 110.273 98.36 126.045C98.36 141.816 111.311 154.715 127.239 154.715C143.167 154.715 156.222 141.868 156.222 126.045C156.222 110.221 143.219 97.4268 127.239 97.4268Z",
    fill: "white",
    stroke: "#343333",
    strokeWidth: 2.61111,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.5 153.776L99.3521 125.89L127.5 98.0029L155.648 125.89L127.5 153.776ZM102.015 125.89L127.5 151.165L152.984 125.89L127.5 100.614L102.015 125.89Z",
    fill: "#343334"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.337 146.674L107.394 146.83L107.551 105.888L148.493 105.731L148.337 146.674ZM109.274 144.898L146.404 144.741L146.561 107.611L109.431 107.768L109.274 144.898Z",
    fill: "#343334"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVintage);
export default __webpack_public_path__ + "static/media/Vintage.6f96fa60e9d0aaf3a70e490cba34c4eb.svg";
export { ForwardRef as ReactComponent };